import { Reveal, MaskLines } from "./motion";

export const SectionHead = ({ eyebrow, lines, intro, light = false, testId }) => (
  <div className="max-w-3xl" data-testid={testId}>
    <Reveal>
      <p className={`mb-5 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] ${light ? "text-[#DCEFBE]" : "text-[#C86D51]"}`}>
        <span className={`h-px w-8 ${light ? "bg-[#DCEFBE]" : "bg-[#C86D51]"}`} />
        {eyebrow}
      </p>
    </Reveal>
    <h2 className={`font-display text-4xl font-medium leading-[1.02] tracking-[-0.02em] sm:text-5xl lg:text-6xl ${light ? "text-[#FBF9F4]" : "text-[#1B281E]"}`}>
      <MaskLines lines={lines} inView />
    </h2>
    {intro && (
      <Reveal delay={0.15}>
        <p className={`mt-6 max-w-xl text-base leading-relaxed md:text-lg ${light ? "text-[#FBF9F4]/85" : "text-[#4B5B4E]"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
